import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import PrimaryButton from 'common/components/buttons/primaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { InputEasyImageWithProcessing } from 'common/components/fields/InputEasyImageWithProcessing';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import UploadVideos from 'common/components/upload';
import { FORM_RULES } from 'helpers/validations';
import _ from 'lodash';
import { requiredFieldError } from 'modules/owner/pages/actions/actionsFile';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Field,
  Form,
  change,
  getFormMeta,
  getFormSyncErrors,
  getFormValues,
  reduxForm,
} from 'redux-form';
import NewSelectMultiple from 'common/components/fields/NewSelectMultiple';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { getList as getCategoriesList } from '../../categories/categoriesActions';
import { getGroupingsStationId, getGroupingsMultipleStations } from '../groupings/groupingsActions';
import {
  getUserStations,
  isClubsMultiStationType,
  isClubsStationContext,
  toActionImageKey,
} from '../helpers/clubsMultiStation';

class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      poppedUp: false,
      userStations: [],
      stationCategories: {},
      loadingCategories: false,
      currentImageStation: null,
      stationImages: {},
    };
    const activeStationId = this.props.auth.user.establishments[0].stations[0].id;
    this.props.getCategoriesList(activeStationId);

    if (this.isMultiStationEnabled()) {
      const stations = getUserStations(this.props.auth);
      const stationIds = stations.map((s) => s.id);
      const stationsMap = stations.reduce((acc, s) => {
        acc[s.id] = s.name || '';
        return acc;
      }, {});
      this.props.getGroupingsMultipleStations(stationIds, stationsMap);
      this.state.userStations = stations;
    } else {
      this.props.getGroupingsStationId(activeStationId);
    }
  }

  isMultiStationEnabled = () => {
    if (this.props.enableMultiStation === false) return false;
    if (this.props.formValues?.is_tanque_cheio) return false;
    // Restrito à entidade/estação Clubs
    if (!isClubsStationContext(this.props.auth)) return false;
    if (this.props.enableMultiStation === true) return true;
    return isClubsMultiStationType(this.props.formValues?.type_id || this.props.typeId);
  };

  componentDidMount() {
    if (this.isMultiStationEnabled()) {
      const stations = getUserStations(this.props.auth);
      this.setState({ userStations: stations });

      if (this.props.formValues?.station_images) {
        this.setState({ stationImages: this.props.formValues.station_images });
      }

      let selected = this.props.formValues?.stations_field || [];
      if (selected.length === 0 && this.props.formValues?.station_id && this.props.change) {
        const current = stations.find((s) => s.id === this.props.formValues.station_id);
        if (current) {
          selected = [{ id: current.id, title: current.name }];
          this.props.change('stations_field', selected);
        }
      }

      if (selected.length > 0) {
        this.fetchCategoriesForSelectedStations(selected);
        // Já abre o upload da imagem do card na primeira station
        if (!this.state.currentImageStation) {
          this.setState({ currentImageStation: selected[0] });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEmpty(this.props.submitErrors) && this.state.submitted && !this.state.poppedUp) {
      this.props.requiredFieldError();
      this.setState({ poppedUp: true, submitted: false });
    }
    if (this.props.submitErrors !== prevProps.submitErrors && this.state.poppedUp) {
      this.setState({ poppedUp: false });
    }

    const prevStations = prevProps.formValues?.stations_field || [];
    const currentStations = this.props.formValues?.stations_field || [];
    if (
      this.isMultiStationEnabled() &&
      JSON.stringify(prevStations.map((s) => s.id)) !==
        JSON.stringify(currentStations.map((s) => s.id))
    ) {
      this.fetchCategoriesForSelectedStations(currentStations);

      // Mantém station de imagem válida; senão usa a primeira selecionada
      const currentStillSelected =
        this.state.currentImageStation &&
        currentStations.some((s) => s.id === this.state.currentImageStation.id);
      if (!currentStillSelected) {
        this.setState({
          currentImageStation: currentStations.length > 0 ? currentStations[0] : null,
        });
      }
    }

    const prevImage = prevProps.formValues?.image;
    const currentImage = this.props.formValues?.image;
    if (
      this.isMultiStationEnabled() &&
      currentImage &&
      currentImage !== prevImage &&
      this.state.currentImageStation
    ) {
      const imagePath = toActionImageKey(currentImage);
      if (imagePath) {
        const stationImages = {
          ...this.state.stationImages,
          [this.state.currentImageStation.id]: imagePath,
        };
        // Sem imagem por station: replica a do card para as demais selecionadas
        const selectedStations = this.props.formValues?.stations_field || [];
        selectedStations.forEach((station) => {
          if (!stationImages[station.id]) {
            stationImages[station.id] = imagePath;
          }
        });
        this.setState({ stationImages });
        this.props.change('station_images', stationImages);
      }
    }
  }

  fetchCategoriesForStation = async (stationId) => {
    if (this.state.stationCategories[stationId]) return;
    try {
      const response = await axios.get(`${BASE_API}/categories`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        params: { 'where[station_id]': stationId },
      });
      const categories = response.data?.content || response.data || [];
      this.setState((prev) => ({
        stationCategories: {
          ...prev.stationCategories,
          [stationId]: Array.isArray(categories) ? categories : [],
        },
      }));
    } catch (error) {
      console.error('Erro ao buscar categorias da station:', error);
    }
  };

  fetchCategoriesForSelectedStations = async (selectedStations) => {
    if (!selectedStations || selectedStations.length === 0) return;
    this.setState({ loadingCategories: true });
    await Promise.all(
      selectedStations.map((station) => this.fetchCategoriesForStation(station.id))
    );
    this.setState({ loadingCategories: false });
  };

  onSubmit = (values) => {
    if (values.categories_field) {
      values.categories = values.categories_field.map((item) => item.id);
    }
    if (values.groupings_field) {
      values.groupings = values.groupings_field.map((item) => item.id);
    }

    if (this.isMultiStationEnabled()) {
      const selectedStations = values.stations_field || [];
      if (selectedStations.length === 0) {
        this.props.requiredFieldError();
        return;
      }

      const stationImages = { ...(this.state.stationImages || {}) };
      const firstImage =
        toActionImageKey(Object.values(stationImages)[0]) || toActionImageKey(values.image);

      if (firstImage) {
        values.image = firstImage;
        values.primaryImageId = firstImage;

        // Replica a imagem principal para stations sem imagem própria
        selectedStations.forEach((station) => {
          const existing = toActionImageKey(stationImages[station.id]);
          stationImages[station.id] = existing || firstImage;
        });
      }

      values.station_images = stationImages;
    }

    values.submitFromButton = true;
    this.props.onClickProgress(values);
  };

  getCategoryOptions = () => {
    if (!this.isMultiStationEnabled()) {
      return (this.props.categories.list.content || []).map((item) => ({
        id: item.id,
        title: item.name,
      }));
    }

    const selectedStations = this.props.formValues?.stations_field || [];
    if (selectedStations.length === 0) {
      return (this.props.categories.list.content || []).map((item) => ({
        id: item.id,
        title: item.name,
      }));
    }

    const options = [];
    selectedStations.forEach((station) => {
      const stationCats = this.state.stationCategories[station.id] || [];
      stationCats.forEach((cat) => {
        options.push({
          id: cat.id,
          title: `${cat.name} (${station.title || station.name})`,
          stationId: station.id,
          stationName: station.title || station.name,
        });
      });
    });
    return options;
  };

  getGroupingOptions = () => {
    if (!this.isMultiStationEnabled()) {
      return (this.props.groupings || []).map((item) => ({
        id: item.id,
        title: item.name,
      }));
    }

    return (this.props.groupings || []).map((item) => ({
      id: item.id,
      title: item.stationName ? `${item.name} (${item.stationName})` : item.name,
      stationId: item.stationId || item.station_id,
    }));
  };

  renderStationImagesSection = (isDisabled) => {
    const selectedStations = this.props.formValues?.stations_field || [];
    const activeStation =
      this.state.currentImageStation || (selectedStations.length > 0 ? selectedStations[0] : null);

    if (selectedStations.length === 0) {
      return (
        <div style={{ marginTop: 20 }}>
          <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
            Imagem do card
          </Typography>
          <Typography variant="body2" style={{ color: '#666', marginTop: 8, marginBottom: 12 }}>
            Selecione stations acima para liberar o upload da imagem do card
          </Typography>
          <MaterialGrid item xs={12}>
            <Box
              style={{
                border: '2px dashed #ddd',
                borderRadius: 8,
                padding: 32,
                textAlign: 'center',
                backgroundColor: '#fafafa',
                minHeight: 160,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Typography variant="body2" color="textSecondary">
                A imagem aparece no preview do card (960×540 · 16:9)
              </Typography>
            </Box>
          </MaterialGrid>
        </div>
      );
    }

    return (
      <div style={{ marginTop: 20 }}>
        <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
          Imagem do card
        </Typography>
        <Typography variant="body2" style={{ color: '#666', marginTop: 4, marginBottom: 12 }}>
          Essa foto aparece no preview do card. Com várias stations, clique em cada uma para trocar
          a imagem específica (senão a mesma é usada em todas).
        </Typography>

        {selectedStations.length > 1 && (
          <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
            {selectedStations.map((station) => {
              const hasImage = Boolean(this.state.stationImages[station.id]);
              const isCurrent = activeStation?.id === station.id;
              return (
                <Chip
                  key={station.id}
                  label={`${hasImage ? '✓ ' : ''}${station.title || station.name}`}
                  onClick={() => this.setState({ currentImageStation: station })}
                  color={isCurrent ? 'primary' : 'default'}
                  style={{
                    backgroundColor: hasImage ? '#4caf50' : isCurrent ? undefined : '#e0e0e0',
                    color: hasImage ? '#fff' : undefined,
                    fontWeight: isCurrent ? 600 : 400,
                  }}
                  disabled={isDisabled}
                />
              );
            })}
          </Box>
        )}

        {!isDisabled && activeStation && (
          <MaterialGrid item xs={12}>
            {selectedStations.length > 1 && (
              <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 600 }}>
                Imagem — {activeStation.title || activeStation.name}
              </Typography>
            )}
            <Field
              component={InputEasyImageWithProcessing}
              label="Clique para adicionar ou trocar a foto do card (.png ou .jpg)"
              cols="12 12 12 12"
              name="image"
              aspect={16 / 9}
              aspectLabel="16:9"
              validate={[FORM_RULES.required]}
            />
          </MaterialGrid>
        )}
      </div>
    );
  };

  render() {
    const multiStation = this.isMultiStationEnabled();
    const categoriesList = this.getCategoryOptions();
    const groupingsList = this.getGroupingOptions();
    const stationOptions = (this.state.userStations || []).map((station) => ({
      id: station.id,
      title: station.name,
    }));

    const atividade = this?.props?.formValues;
    const now = new Date();
    const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);

    return (
      <>
        <Form
          role="form"
          onSubmit={this.props.handleSubmit(this.onSubmit)}
          noValidate
          style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <div
            style={{
              overflowY: 'auto',
              maxHeight: isMobile ? 'calc(100vh - 240px)' : 'calc(95vh - 220px)',
              overflowX: 'hidden',
              padding: '0 10px',
              WebkitOverflowScrolling: 'touch',
              flex: '1 1 auto',
              minHeight: 0,
            }}>
            {multiStation && (
              <div style={{ marginTop: isMobile ? 0 : 20 }}>
                <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                  Publicar nas Stations
                </Typography>
                <MaterialGrid container spacing={3}>
                  <MaterialGrid item xs={12}>
                    <Field
                      component={NewSelectMultiple}
                      label="Selecione as Stations"
                      options={stationOptions}
                      name="stations_field"
                      margin="normal"
                      disabled={isDisabled}
                    />
                  </MaterialGrid>
                </MaterialGrid>
              </div>
            )}

            <div style={{ marginTop: isMobile || multiStation ? 20 : 20 }}>
              <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                Categoria
              </Typography>
              <MaterialGrid container spacing={3}>
                <MaterialGrid item xs={12}>
                  <Field
                    component={NewSelectMultiple}
                    label="Categorias"
                    options={categoriesList}
                    name="categories_field"
                    margin="normal"
                    disabled={isDisabled || (multiStation && this.state.loadingCategories)}
                  />
                </MaterialGrid>
              </MaterialGrid>
            </div>

            <div style={{ marginTop: 20 }}>
              <MaterialGrid item xs={12}>
                <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                  Título
                </Typography>
                <Field
                  component={InputLabelOutlined}
                  label="Nome dessa atividade"
                  name="name"
                  validate={[FORM_RULES.required, FORM_RULES.maxL(60)]}
                  required
                  margin="normal"
                  maxLength={60}
                  disabled={isDisabled}
                />
              </MaterialGrid>
            </div>

            {multiStation
              ? this.renderStationImagesSection(isDisabled)
              : !isDisabled && (
                  <div style={{ marginTop: 20 }}>
                    <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                      {parseInt(this.props.formValues?.type_id, 10) === 18
                        ? 'Capa da atividade'
                        : 'Imagem do card'}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: '#666', marginTop: 4, marginBottom: 12 }}>
                      Essa foto aparece no preview do card (960×540 · 16:9)
                    </Typography>
                    <MaterialGrid item xs={12}>
                      <Field
                        component={InputEasyImageWithProcessing}
                        label="Clique para adicionar ou trocar a foto do card (.png ou .jpg)"
                        cols="12 12 12 12"
                        name="image"
                        aspect={16 / 9}
                        aspectLabel="16:9"
                        validate={[FORM_RULES.required]}
                      />
                    </MaterialGrid>
                  </div>
                )}

            <div style={{ marginTop: isMobile ? 0 : 20 }}>
              <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                Agrupamento
              </Typography>
              <MaterialGrid container spacing={3}>
                <MaterialGrid item xs={12}>
                  <Field
                    component={NewSelectMultiple}
                    label="Grupos"
                    options={groupingsList}
                    name="groupings_field"
                    margin="normal"
                    disabled={isDisabled}
                  />
                </MaterialGrid>
              </MaterialGrid>
            </div>

            {parseInt(this.props.formValues?.type_id, 10) !== 20 ? (
              <div style={{ marginTop: 20 }}>
                <MaterialGrid item xs={12}>
                  <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                    Texto do botão
                  </Typography>
                  <Field
                    component={InputLabelOutlined}
                    label="Label do card (Ex: Participe)"
                    name="click_me_label"
                    required
                    margin="normal"
                    disabled={isDisabled}
                  />
                </MaterialGrid>
              </div>
            ) : null}

            {parseInt(this.props.formValues?.type_id, 10) !== 18 ? (
              <div style={{ marginTop: 25 }}>
                <MaterialGrid item xs={12}>
                  <Field
                    component={EditorConvertToHTMLActivity}
                    label="Conteúdo da postagem"
                    name="description"
                    imageRatio="none"
                    disabled={isDisabled}
                  />
                </MaterialGrid>
              </div>
            ) : null}

            {this.props.formValues && parseInt(this.props.formValues.type_id, 10) !== 18 ? (
              <MaterialGrid item xs={12} style={{ margin: '25px 0px' }}>
                <Field
                  component={UploadVideos}
                  indexVideo={0}
                  multipleVideos={false}
                  formValues={this.props.formValues ? this.props.formValues : null}
                  name="videoIdField"
                  disabled={isDisabled}
                />
              </MaterialGrid>
            ) : null}

            <GenericConfirmationCard
              open={this.props.openConfirmation}
              cancelClose={this.props.handleCancelClose}
              maxWidthFixed
              labelLeftButton="Continuar aqui"
              labelRightButton={this.props.buttonConfirmationLabel}
              general={this.props.general}
              confirmButtonColor="primary"
              title={this.props.confirmationTitle}
              text={this.props.confirmationSubtitle}
              onClose={() => this.props.setOpenConfirmation(false)}
              onClick={this.props.closeModal}
            />
          </div>
          <MaterialGrid
            container
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            style={{
              margin: '25px 0px',
              overflowX: 'hidden',
              paddingRight: isMobile ? 0 : 29,
              textTransform: 'none',
            }}>
            <PrimaryButton
              type="submit"
              color="secondary"
              disabled
              style={{
                margin: 0,
                width: '48%',
                padding: '10px 20px',
                textTransform: 'none',
              }}>
              Voltar
            </PrimaryButton>
            <PrimaryButton
              type="submit"
              color="primary"
              onClick={() => this.setState({ submitted: true })}
              disabled={this.props.activeActions.buttonLoading || isDisabled}
              style={{
                margin: 0,
                width: '48%',
                padding: isMobile ? '11px 20px' : '10px 20px',
                textTransform: 'none',
                fontSize: isMobile ? 12 : undefined,
              }}>
              Salvar e continuar
            </PrimaryButton>
          </MaterialGrid>
        </Form>
      </>
    );
  }
}

Content.propTypes = {
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.any,
  }),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  buttonConfirmationLabel: PropTypes.any,
  categories: PropTypes.shape({
    list: PropTypes.shape({
      content: PropTypes.shape({
        map: PropTypes.func,
      }),
    }),
  }),
  change: PropTypes.func,
  closeModal: PropTypes.func,
  confirmationSubtitle: PropTypes.any,
  confirmationTitle: PropTypes.any,
  enableMultiStation: PropTypes.bool,
  form: PropTypes.string,
  formValues: PropTypes.shape({
    type_id: PropTypes.any,
    stations_field: PropTypes.array,
    station_images: PropTypes.object,
    image: PropTypes.any,
    is_draft: PropTypes.any,
    end: PropTypes.any,
    is_tanque_cheio: PropTypes.any,
  }),
  general: PropTypes.any,
  getCategoriesList: PropTypes.func,
  getGroupingsMultipleStations: PropTypes.func,
  getGroupingsStationId: PropTypes.func,
  groupings: PropTypes.array,
  handleCancelClose: PropTypes.any,
  handleSubmit: PropTypes.func,
  onClickProgress: PropTypes.func,
  openConfirmation: PropTypes.any,
  requiredFieldError: PropTypes.func,
  setOpenConfirmation: PropTypes.func,
  submitErrors: PropTypes.any,
  typeId: PropTypes.number,
};

Content.defaultProps = {
  enableMultiStation: undefined,
  typeId: undefined,
};

const mapStateToProps = (state, { form }) => {
  return {
    auth: state.auth,
    activeActions: state.activeActions,
    categories: state.categories,
    groupings: state.groupings.list,
    general: state.general,
    formValues: getFormValues(form)(state),
    submitErrors: getFormSyncErrors(form)(state),
    metaForm: getFormMeta(form)(state),
    form,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    {
      getCategoriesList,
      getGroupingsStationId,
      getGroupingsMultipleStations,
      requiredFieldError,
      change: (field, value) => change(ownProps.form, field, value),
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Content)
);
